import * as React from 'react'

import {
  StoryStream,
  StoryStreamProps,
} from '@thg-commerce/enterprise-widget-story-stream'
import { useSiteConfig } from '@thg-commerce/enterprise-core'

export const StoryStreamRenderer = () => {
  const {
    storyStreamJavaScriptBaseUrl,
    storyStreamPdpLayoutClass,
    storyStreamPdpAppId,
    storyStreamPdpIntegrityHashKey,
  } = useSiteConfig()

  if (
    !storyStreamPdpLayoutClass ||
    !storyStreamPdpAppId ||
    !storyStreamPdpIntegrityHashKey ||
    !storyStreamJavaScriptBaseUrl
  ) {
    return null
  }

  const storyStreamProps: StoryStreamProps = {
    storyStreamJavaScriptBaseUrl,
    layoutClass: storyStreamPdpLayoutClass,
    storyStreamId: storyStreamPdpAppId,
    integrityHash: storyStreamPdpIntegrityHashKey,
    addStoryStreamTitle: true,
  }

  return <StoryStream {...storyStreamProps} />
}
